export const msalConfig = {
  auth: {
    clientId: "bc54e3c2-e53c-46ef-a725-ebe4bf1729a7",
    authority: "https://login.microsoftonline.com/dtc.co.th",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// ใช้ Microsoft Graph - Sites.Read.All
// Admin ต้อง Grant consent ใน Azure Portal ก่อนค่ะ
// ⚠️ ห้ามเพิ่ม scope ที่ยังไม่ได้ admin consent ลงในนี้ — loginRequest ตัวนี้ถูกใช้
// ทั่วทั้งแอป (DataContext.jsx) ถ้า scope ไหนยังไม่ consent จะทำให้ "ทุกหน้า"
// เด้ง popup "Need admin approval" ไปด้วย ไม่ใช่แค่ฟีเจอร์ที่ใช้ scope นั้น
export const loginRequest = {
  scopes: [
    "https://graph.microsoft.com/Sites.Read.All",
    "https://graph.microsoft.com/User.Read",
    "https://graph.microsoft.com/User.ReadBasic.All",  // ดึงรูปของทุกคน
    "https://graph.microsoft.com/User.Read.All",       // ดึง department ของทุกคน (admin consent)
  ],
};

// scope แยกสำหรับฟีเจอร์ "ประชุมออนไลน์ (Teams)" เท่านั้น — ขอแยกตอนใช้งานจริง
// (ตอนนี้ฟีเจอร์ปิดอยู่ผ่าน ONLINE_MEETING_ENABLED ใน SecretaryRoom.jsx)
// รอ admin grant consent scope นี้ก่อนถึงจะใช้ได้จริง
export const onlineMeetingRequest = {
  scopes: ["https://graph.microsoft.com/OnlineMeetings.ReadWrite"],
};
